import { createSelector } from '@reduxjs/toolkit'
import { OptimizelyFeatureFlags } from 'constants/optimizely'

export const selectIsFlightChangeDateTripRequestEnabled = createSelector(
  (state: App.State) => state.optimizely.optimizelyFeatureFlags,
  (optimizelyFeatureFlags): boolean =>
    !!optimizelyFeatureFlags[OptimizelyFeatureFlags.lebtFlightChangeDateTripRequestEnabled],
)
